//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../no/ugmath.js";
let d=[[],[[["entity"],"SelectEntity",{},1,0],[["entities"],"SelectEntities",{},1,0],[["numEntities"],"GetEntities",{R_:{entities:""}},0,0],[[],"Clear",{},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.CrayonSelectionData = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.CrayonSelectionData";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.CrayonSelectionData.EntityData = class{
    constructor(entity,pickPoint,view){
        this.entity=entity;this.pickPoint=pickPoint;this.view=view;}
    get Entity(){return this.entity}
    set Entity(val){this.entity = val}
    get Pickpoint(){if(this.pickPoint === undefined) this.pickPoint = new SPLM.Point3d(); return this.pickPoint}
    set Pickpoint(val){this.pickPoint = val}
    get View(){return this.view}
    set View(val){this.view = val}
};

export default SPLM;